import { QCBadge, StatusBadge } from '@/components/UI';
import type { QCStatus } from '@/types';
import { Stack, type StackProps } from '@nautilusbio/nb-design-system/Stack';
import { Text } from '@nautilusbio/nb-design-system/Text';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import type { InstrumentRunPublic } from '../../types';

import styles from './styles.module.css';

type Props = {
  run: InstrumentRunPublic;
};

const sharedStackProps: StackProps = {
  alignItems: 'center',
  gap: 2,
  justifyContent: 'center',
  orientation: 'vertical',
};

const RunStatusGrid = ({ run }: Props) => {
  const { t } = useTranslation('runs', { keyPrefix: 'header' });

  return (
    <Stack className={styles.statusGrid} orientation="horizontal">
      <Stack className={styles.statusColumn} {...sharedStackProps}>
        <Text as="span" className={styles.statusLabel}>
          {t('instrument_status')}
        </Text>

        {run.status ? <StatusBadge className={styles.qc} status={run.status} /> : <Text size="sm">—</Text>}
      </Stack>

      <Stack className={styles.statusColumn} {...sharedStackProps}>
        <Text as="span" className={styles.statusLabel}>
          {t('decode_status')}
        </Text>

        {run.decode_status ? (
          <StatusBadge className={styles.qc} status={run.decode_status} />
        ) : (
          <Text size="sm">—</Text>
        )}
      </Stack>

      <Stack className={styles.statusColumn} {...sharedStackProps}>
        <Text as="span" className={styles.statusLabel}>
          {t('sample_qc')}
        </Text>

        {run.sample_qc ? (
          <QCBadge className={styles.qc} qc={run.sample_qc as QCStatus} />
        ) : (
          <Text className={styles.qc} size="sm">
            —
          </Text>
        )}
      </Stack>
    </Stack>
  );
};

export default memo(RunStatusGrid);
